import { Interview, InterviewAccessDetail } from '@synergetx/puppet-interview-types';
import { toast } from 'react-toastify';
import { getSingleObject, updateObject } from './firestore-utils';
import { logError } from '../logging';

const INTERVIEWS = 'Interviews';
const GROUPS = 'Groups';

export const saveInterview = async (groupId: string, interview: Partial<Interview>) =>
    toast
        .promise(
            updateObject<Interview>(
                interview,
                `${GROUPS}/${groupId}/${INTERVIEWS}`,
                'saveInterview',
            ),
            {
                pending: 'Saving survey...',
                error: 'Error saving survey',
                success: 'Survey saved successfully!',
            },
            { autoClose: 2000 },
        )
        .catch((e) => {
            console.error('ERROR!! Changes NOT saved successfully!', e);
            console.error(e);
            return null;
        });

export const getInterviewsForUser = async (
    availableInterviews: InterviewAccessDetail[],
): Promise<Interview[]> =>
    (
        await Promise.all(
            availableInterviews.map(({ interviewId, groupId }) =>
                getSingleObject<Interview>(
                    `${GROUPS}/${groupId}/${INTERVIEWS}/${interviewId}`,
                    'getInterviewsForUser',
                    false,
                ),
            ),
        ).catch((error) => {
            logError(error);
            return [];
        })
    ).filter((i) => !!i) as Interview[];
